import {
  completeApplication,
  getApplication,
  saveApplication,
  deleteApplication,
  requestCode,
} from './Action'
import { selectApplicationData, selectApplicationState } from './Selector'
import { applicationSlice, initialState } from './Slice'

export type { ApplicantApplicationState } from './Type'
export { saveApplication, completeApplication, getApplication, deleteApplication, requestCode }
export { initialState, applicationSlice }
export { selectApplicationData, selectApplicationState }

export default applicationSlice.reducer
